import { Color } from '@web-apps/utils-shared'
import { CreatorPageType, CustomizationPropsType } from '@web-apps/utils-types'
import { FC } from 'react'

export enum LINK_SERVICES {
  linktree = 'linktree',
  instagram = 'instagram',
  profile_1 = 'profile_1',
}

export type ServicesSlugsMap = {
  [service in LINK_SERVICES]?: string
}

export type FormDataType = {
  [LINK_SERVICES.instagram]: string
}

export type ErrorType = {
  message: string
  serviceType?: LINK_SERVICES
}

export type NormalizedFetchedData = {
  creatorPage: CreatorPageType
  colors: Color[]
}

export type MergeAccountsType = {
  [page in LINK_SERVICES]?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    profile: any
    colors?: {
      paletteColors: Color[]
    }
  }
}

export type MergeAccountOptionsType = {
  messages: {
    productRecommendationsSection: {
      title: string
    }
  }
}

export type LoadingScreenSlideType = {
  titleKey: string
  descriptionKey: string
  SVGComponent: FC
}

export type PreviewThemeType = CustomizationPropsType & {
  themeName: string
  avatarAsBackground?: boolean
}
